import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OurAuthService } from 'app/core/auth/auth.service';

/** Role-aware landing route after authentication (replaces static redirectTo: 'dashboard'). */
export const signedInRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const auth = inject(OurAuthService);

    return router.parseUrl(auth.getDefaultAuthenticatedLandingUrl());
};
